<script setup lang="ts">
interface Props {
  label?: string | number
  color?: 'primary' | 'gray' | 'red' | 'green' | 'blue' | 'yellow' | 'orange' | 'purple'
  variant?: 'solid' | 'outline' | 'soft' | 'subtle'
  size?: 'xs' | 'sm' | 'md' | 'lg'
}

const props = withDefaults(defineProps<Props>(), {
  color: 'primary',
  variant: 'soft',
  size: 'sm'
})

const sizeClasses = {
  xs: 'text-xs px-1.5 py-0.5',
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-0.5',
  lg: 'text-sm px-3 py-1'
}

const colorVariants = {
  primary: {
    solid: 'bg-primary-500 text-white',
    outline: 'border border-primary-500 text-primary-500',
    soft: 'bg-primary-100 text-primary-700',
    subtle: 'bg-primary-50 text-primary-500'
  },
  gray: {
    solid: 'bg-gray-500 text-white',
    outline: 'border border-gray-500 text-gray-500',
    soft: 'bg-gray-100 text-gray-700',
    subtle: 'bg-gray-50 text-gray-500'
  },
  red: {
    solid: 'bg-red-500 text-white',
    outline: 'border border-red-500 text-red-500',
    soft: 'bg-red-100 text-red-700',
    subtle: 'bg-red-50 text-red-500'
  },
  green: {
    solid: 'bg-green-500 text-white',
    outline: 'border border-green-500 text-green-500',
    soft: 'bg-green-100 text-green-700',
    subtle: 'bg-green-50 text-green-500'
  },
  blue: {
    solid: 'bg-blue-500 text-white',
    outline: 'border border-blue-500 text-blue-500',
    soft: 'bg-blue-100 text-blue-700',
    subtle: 'bg-blue-50 text-blue-500'
  },
  yellow: {
    solid: 'bg-yellow-500 text-white',
    outline: 'border border-yellow-500 text-yellow-500',
    soft: 'bg-yellow-100 text-yellow-700',
    subtle: 'bg-yellow-50 text-yellow-500'
  },
  orange: {
    solid: 'bg-orange-500 text-white',
    outline: 'border border-orange-500 text-orange-500',
    soft: 'bg-orange-100 text-orange-700',
    subtle: 'bg-orange-50 text-orange-500'
  },
  purple: {
    solid: 'bg-purple-500 text-white',
    outline: 'border border-purple-500 text-purple-500',
    soft: 'bg-purple-100 text-purple-700',
    subtle: 'bg-purple-50 text-purple-500'
  }
}

const badgeClasses = computed(() => [
  'inline-flex items-center font-medium rounded-full',
  sizeClasses[props.size],
  colorVariants[props.color]?.[props.variant] || colorVariants.primary.soft
])
</script>

<template>
  <span :class="badgeClasses">
    <slot>{{ label }}</slot>
  </span>
</template>
